import FilterAreaBlock from './FilterAreaBlock';
export default FilterAreaBlock;
